<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="localVisible"
    width="800px"
    @close="$emit('closeDialog')"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <!-- 类型 -->
        <el-col :span="12">
          <el-form-item label="类型" prop="type">
            <el-select v-model="formData.type">
              <el-option label="供应" :value="2" />
              <el-option label="求购" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 产品种类 -->
        <el-col :span="12">
          <el-form-item label="产品种类" prop="productCategoryId">
            <el-cascader
              ref="productCategory"
              v-model="formData.productCategoryId"
              :options="categoryOptions"
              :props="{
                ...categoryProps,
                emitPath: false,
                checkStrictly: true
              }"
              :show-all-levels="false"
              placeholder="请选择产品种类"
              @change="handleCategoryChange"
            />
          </el-form-item>
        </el-col>

        <!-- 数量 -->
        <el-col :span="24">
          <el-form-item label="数量" prop="num">
            <div style="display: flex; align-items: center; gap: 10px">
              <el-input-number v-model="formData.num" :min="1" />
              <el-select v-model="formData.unit" placeholder="选择单位" style="width: 120px">
                <el-option label="吨" value="吨" />
                <el-option label="公斤" value="公斤" />
                <el-option label="斤" value="斤" />
                <el-option label="件" value="件" />
                <el-option label="个" value="个" />
              </el-select>
            </div>
          </el-form-item>
        </el-col>

        <!-- 价格 -->
        <el-col :span="24">
          <el-form-item label="价格" prop="price">
            <el-input v-model="formData.price" />
          </el-form-item>
        </el-col>

        <!-- 地址 -->
        <el-col :span="24">
          <el-form-item label="交货地点" prop="areaCode">
            <el-cascader ref="address" v-model="formData.areaCode" :props="props" :options="addressOptions"
              :show-all-levels="false" @change="regionChange" clearable></el-cascader>
          </el-form-item>
        </el-col>

        <!-- 联系电话 -->
        <el-col :span="24">
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="formData.phone" readonly />
          </el-form-item>
        </el-col>

        <!-- 补充说明 -->
        <el-col :span="24">
          <el-form-item label="补充说明" prop="remark">
            <el-input
              v-model="formData.memo"
              type="textarea"
              :rows="3"
              placeholder="请输入补充说明"
            />
          </el-form-item>
        </el-col>


        <!-- 图片上传 -->
        <el-col :span="24">
          <el-form-item label="相关图片" prop="img">
            <el-upload
              action="/api/upload"
              list-type="picture-card"
              :file-list="imageList"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :http-request="handleSingleUpload"
              :on-remove="handleRemove"
              :limit="9"
              multiple
            >
              <i class="el-icon-plus" />
            </el-upload>
            <el-image-viewer
              v-if="showPreview"
              :url-list="previewList"
              @close="showPreview = false"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getXzqArr } from "@/api/add";
import { removeEmptyChildren } from "@/js/utils/util";
import { getSupplyOrderList, getProductCategoryTree,addSupplyOrder,editSupplyOrder,getSupplyOrderDetail } from '@/api/supplyOrder';
import { uploadFile, deleteFile } from "@/api/fileApi";
import { mapGetters } from "vuex";
export default {
  name: "AddEdit",
  props: {
    visible: Boolean,
    editData: Object
  },
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      formData: {
        id: null,
        cropName: '',
        num: '',
        unit: '',
        price: '',
        areaCode: '',
        address: '',
        phone: '',
        centerPoint: '',
        memo: '',
        productCategoryId: '',
        type: '',
        img: ''
      },
      rules: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        category: [{ required: true, message: '请选择产品种类', trigger: 'change' }],
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
        ],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }]
      },
      categoryOptions: [], // 需要从接口获取三级分类数据
      addressOptions: [], // 需要从接口获取地址数据
      localVisible: this.visible,
      props: {
        label: "areaName",
        children: "children",
        value: "id",
        checkStrictly: true,
      },
      categoryProps: {
        label: 'name',
        value: 'id',
        children: 'children',
        checkStrictly: true,
        expandTrigger: 'hover',
        emitPath: false // 确保只返回最后一级值
      },
      imageList: [],
      showPreview: false,
      previewList: [],
      imgList: [],
    }
  },
  computed: mapGetters(["userInfo", "identityObj"]),
  watch: {
    visible(val) {
      console.log('显示', val);
      this.localVisible = val;
      console.log(this.editData, 'this.editData')
      console.log(this.identityObj, 'this.identityObj')
      if (val) {
        this.formData = this.editData ? this.getDetail(this.editData.id) : this.getInitialData()
        this.submitText = this.editData ? '保存' : '发布'
        this.dialogTitle = this.editData ? '编辑' : '发布'
      }
    }
  },
  mounted() {
    this.getRegions()
    this.getProductCategoryTree()
  },
  methods: {
    getInitialData() {
      return {
        // 初始化表单数据结构
        id: null,
        cropName: '',
        num: '',
        unit: '',
        price: '',
        areaCode: '',
        address: '',
        phone: this.identityObj.contactPhone,
        centerPoint: '',
        memo: '',
        productCategoryId: '',
        type: '',
        img: []
      }
    },
    //获取详情
    async getDetail(id) {
      let res = await getSupplyOrderDetail({id});
      if (res.code == 0) {
        this.formData = res.data
        this.formData.areaCode = Number(res.data.areaCode)
        this.imageList = this.editData ? JSON.parse(res.data.img).map(item => ({ ...item, url: this.baseUrl + 'admin/file/get?ossFilePath=' + item.url })) : []
        this.imgList = this.editData ? JSON.parse(res.data.img) : []
      }
    },
    beforeUpload(file) {
      const isImage = file.type.includes('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片格式!')
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB!')
      }
      return isImage && isLt5M
    },
    async handleSingleUpload(file) {
        let param = new FormData();
        param.append("catalog", "supplyOrder");
        param.append("file", file.file);
        return await uploadFile(param);
    },
    async handleUploadSuccess(res, file) {
       if (res.code == 0) {
        this.imgList = [
          ...this.imgList, // 保留已有图片
          {
            uid: file.uid,
            url: res.data.url,
            name: file.name
          }
        ]
        this.$message.success(`上传成功`)
      }
    },
    handleRemove(file, fileList) {
      this.imageList = fileList
      this.imgList = this.imgList.filter(
        item => item.uid !== file.uid // 根据uid过滤
      )
    },
    handlePreview(file) {
      this.previewList = [file.url]
      this.showPreview = true
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        // 提交逻辑
        const submitData = {
          ...this.formData,
          img: JSON.stringify(this.imgList)
        }
        //区分新增和修改
        if (this.editData) {
          let res = await editSupplyOrder(submitData)
          if (res.code == 0) {
            this.$message.success('修改成功')
            this.localVisible = false;
            //刷新列表
            this.$emit('loadProducts')
          } else {
            this.$message.error(res.msg)
            this.localVisible = false;
          }
        } else {
          let res = await addSupplyOrder(submitData)
          if (res.code == 0) {
            this.$message.success('添加成功')
            this.localVisible = false;
             //刷新列表
            this.$emit('loadProducts')
          } else {
            this.$message.error(res.msg)
            this.localVisible = false;
          }
        }
      } catch (error) {
        console.error('表单验证失败:', error);
      }
    },
    async getRegions() {
      // 获取地区信息
      let res = await getXzqArr({
        level: 5,
      });
      if (res.code == 0) {
        let hasRegion = setInterval(() => {
          this.addressOptions = removeEmptyChildren(res.data);
          this.keyForm++;
          clearInterval(hasRegion);
        }, 100);
      }
    },
    //行政区做切换
    regionChange() {
      let node = this.$refs.address.getCheckedNodes()[0];
      console.log(node,'查看node')
      this.areaHasChild = node.hasChildren;
      this.formData.areaCode = node.value;
      this.formData.address = node.pathLabels.join("/");
      const [lng, lat] = node.data.centerPoint.split(',').map(Number);
      this.formData.centerPoint = [
        parseFloat(lng.toFixed(6)),
        parseFloat(lat.toFixed(6))
      ];
      console.log(this.formData.address, 'ahhah ')
    },

    //获取产品种类
    async getProductCategoryTree() {
      let res = await getProductCategoryTree({
        type: 1,
      });
      if (res.code == 0) {
        this.categoryOptions = res.data;
      }
    },
    handleCategoryChange() {
      const nodes = this.$refs.productCategory.getCheckedNodes()
      if (nodes?.length > 0) {
        this.formData.cropName = nodes[0].pathLabels?.pop() || ''
      } else {
        this.formData.cropName = ''
      }
      console.log('当前作物名称:', this.formData.cropName)
    },
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body {
  padding: 20px 30px;
}

.el-form-item {
  margin-bottom: 18px;
}
.unit {
  margin-left: 10px;
  color: #666;
}
</style>
